import { publicClient } from '@/core/publicClient';

export const animalsPublicApi = {
  // Public catalog with filters + pagination
  search: async (query: Record<string, any>) => {
    const res = await publicClient.get('/public/animals', { params: query });
    return res.data; // { data, total, page, pageSize }
  },
  // Lookups used by at least one adoptable animal (for public filters)
  activeLookups: async (includeInAdoption?: boolean) => {
    const params: Record<string, any> = {};
    if (includeInAdoption) params.includeInAdoption = true;
    const res = await publicClient.get('/public/animals/active-lookups', { params });
    return res.data; // { species, sexes, sizes, breeds, shelters }
  },
  // Public details (only if adoptable)
  getWithPhotos: async (id: number) => {
    const res = await publicClient.get(`/public/animals/${id}`);
    const body = res.data;
    return body?.data ?? body;
  },
  // Public status counts
  statusCounts: async (): Promise<{ available: number; inAdoption: number; adopted: number }> => {
    const res = await publicClient.get('/public/animals/status-counts');
    const body = res.data;
    return body?.data ?? body;
  },
  // Public shelters list
  getShelters: async () => {
    const res = await publicClient.get('/public/shelters');
    const body = res.data;
    return Array.isArray(body) ? body : (body?.data || []);
  },
};
